import type { InboundProviderPresenter } from '../../types'

export const framerInboundPresenter: InboundProviderPresenter = {
  providerId: 'framer',
  displayName: 'Framer',
  categories: [{ id: 'forms', label: 'Forms' }],
  events: [],
  eventSource: 'configured_forms',
  triggerEventId: ({ orgId, brandId, eventType }) =>
    `framer:${orgId}:${brandId}:${eventType}`,
}
